export const INVESTMENT_OBJECTIVE_LABELS: Record<string, string> = {
  CAP: 'Capital preservation',
  Income: 'Income',
  Growth: 'Growth',
  Speculation: 'Speculation',
};
